import { useState } from 'react';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 24,
};

const labelStyle = {
  fontSize: 20,
  color: 'rgba(255,255,255,0.9)',
  fontFamily: "'League Spartan', Arial, sans-serif",
  textAlign: 'center',
};

const scaleRowStyle = {
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
  justifyContent: 'center',
};

const btnBase = {
  width: 44,
  height: 44,
  borderRadius: '50%',
  border: '2px solid rgba(255,255,255,0.4)',
  background: 'transparent',
  color: '#fff',
  fontFamily: "'League Spartan', Arial, sans-serif",
  fontWeight: 700,
  fontSize: 16,
  cursor: 'pointer',
};

const btnSelected = {
  ...btnBase,
  background: '#fff',
  color: '#55B4BE',
  border: '2px solid #fff',
};

const confirmBtnStyle = {
  padding: '12px 28px',
  fontSize: 17,
  fontFamily: "'League Spartan', Arial, sans-serif",
  fontWeight: 700,
  color: '#55B4BE',
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: 100,
  cursor: 'pointer',
};

const confirmBtnDisabled = {
  ...confirmBtnStyle,
  opacity: 0.4,
  cursor: 'default',
};

export default function PartnerRating({ onConfirm }) {
  const [selected, setSelected] = useState(null);

  return (
    <div style={containerStyle}>
      <span style={labelStyle}>Como você avalia a compatibilidade de vocês como parceiros de estudo? (1–10)</span>
      <div style={scaleRowStyle}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
          <button
            key={n}
            type="button"
            style={selected === n ? btnSelected : btnBase}
            onClick={() => setSelected(n)}
          >
            {n}
          </button>
        ))}
      </div>
      <button
        type="button"
        style={selected ? confirmBtnStyle : confirmBtnDisabled}
        disabled={!selected}
        onClick={() => onConfirm(selected)}
      >
        Next →
      </button>
    </div>
  );
}
